import { z } from 'zod';
import { localeSchema } from '../locale.js';
/**
 * Request body для POST /auth/yandex/callback
 * Клиент отправляет code и state после редиректа от Яндекса
 */
export const yandexAuthCallbackSchema = z.object({
    code: z.string().min(1, 'Authorization code is required'),
    state: z.string().min(1, 'State is required'),
    timeZone: z.string().min(1).optional(),
    locale: localeSchema.optional(),
    source: z.enum(['webapp', 'bot']).optional(),
    /** WUID визита на лендинге — связывает регистрацию с источником. */
    wuid: z.string().min(12).max(128).optional(),
});
/**
 * Ответ от Яндекс OAuth token endpoint
 * POST https://oauth.yandex.ru/token
 */
export const yandexTokenResponseSchema = z.object({
    access_token: z.string(),
    expires_in: z.number(),
    token_type: z.string(),
    refresh_token: z.string().optional(),
});
/**
 * Ответ от Яндекс user info endpoint
 * GET https://login.yandex.ru/info
 */
export const yandexUserInfoSchema = z.object({
    id: z.string(),
    login: z.string(),
    client_id: z.string(),
    display_name: z.string().optional(),
    real_name: z.string().optional(),
    first_name: z.string().optional(),
    last_name: z.string().optional(),
    sex: z.enum(['male', 'female']).nullable().optional(),
    default_email: z.string().email().optional(),
    emails: z.array(z.string().email()).optional(),
    default_avatar_id: z.string().optional(),
    is_avatar_empty: z.boolean().optional(),
});
//# sourceMappingURL=yandex-auth.js.map